@if (isOverflowing()) {
	<button #chevronStart class="chevronButton" mat-icon-button (click)="doScrollViewport('start')" color="accent" [disabled]="isStart()">
		<mat-icon fontIcon="fa-chevron-left" fontSet="fas" />
	</button>
	<mat-divider vertical [class.visible]="!isStart()" />
}

<div #viewport class="scrollViewport">
	<div #boundStart class="bound start"></div>
	<ng-content />
	<div #boundEnd class="bound end"></div>
</div>

@if (isOverflowing()) {
	<mat-divider vertical [class.visible]="!isEnd()" />
	<button #chevronEnd class="chevronButton" mat-icon-button (click)="doScrollViewport('end')" color="accent" [disabled]="isEnd()">
		<mat-icon fontIcon="fa-chevron-right" fontSet="fas" />
	</button>
}
